import type { EnvironmentHints } from "./types";

// See EnvironmentHints in types.ts for the platform caveats (Network
// Information API is Chromium-only; WebKit clamps hardwareConcurrency).
export function collectEnvironmentHints(): EnvironmentHints | undefined {
  if (typeof navigator === "undefined") return undefined;

  const hints: EnvironmentHints = {};
  const connection = (navigator as { connection?: { effectiveType?: unknown } })
    .connection;
  if (typeof connection?.effectiveType === "string") {
    hints.network_effective_type = connection.effectiveType;
  }
  if (typeof navigator.hardwareConcurrency === "number") {
    hints.hardware_concurrency = navigator.hardwareConcurrency;
  }

  return Object.keys(hints).length > 0 ? hints : undefined;
}
